<template>
    <div class="share-page">
        <!-- 加载状态 -->
        <div class="loading-container" v-if="loading">
            <van-loading type="spinner" color="#533afd" size="36px">加载中...</van-loading>
        </div>

        <!-- 错误状态 -->
        <div class="error-container" v-else-if="error">
            <div class="error-icon">!</div>
            <div class="error-text">{{ error }}</div>
        </div>

        <!-- 详情内容 -->
        <template v-else-if="detail">
            <!-- Top Bar -->
            <div class="top-bar">
                <div class="logo-box">
                    <img class="logo-img" src="https://7niu.deepagens.com/sd/static/img/favicon2.png" alt="深度云海" />
                </div>
                <div class="top-bar-left">
                    <h1 class="top-bar-title">GEO大模型搜索优化</h1>
                    <p class="top-bar-sub">让AI大模型主动为您的品牌推荐</p>
                </div>
                <div class="top-bar-right">
                    <span class="top-brand">Deepagens AI SEARCH</span>
                    <span class="top-divider"></span>
                    <span class="top-tagline">抢占AI搜索时代流量入口</span>
                </div>
            </div>

            <div class="main-content">
                <!-- 价格栏 -->
                <div class="price-bar">
                    <div class="tag-row">
                        <div class="tag-item">
                            <span class="tag-icon green">&#10003;</span>
                            <span>TOP 10 渗透率承诺</span>
                        </div>
                        <div class="tag-item">
                            <span class="tag-icon blue">&#9679;</span>
                            <span>六大AI平台覆盖</span>
                        </div>
                        <div class="tag-item">
                            <span class="tag-icon orange">&#9679;</span>
                            <span>7天开始上榜</span>
                        </div>
                    </div>
                    <div class="price-text">
                        <div class="price-desc">
                            <span class="price-type-tag" v-if="detail.usePriceType == specialOfferPriceType">{{ detail.specialOfferTypeTitle || "直通车" }}</span>
                            <span class="price-type-tag activity" v-else-if="detail.usePriceType == activityPriceType">{{ detail.activityTitle || "活动优惠" }}</span>
                            <span v-else>专享报价</span>
                        </div>
                        <div class="price-row">
                            <span class="price-original tnum" v-if="detail.showPrice">￥{{ detail.price }}</span>
                            <span class="price-num tnum">￥{{ detail.payPrice }}</span>
                        </div>
                    </div>
                </div>

                <!-- 核心服务指标 -->
                <div class="section-title">核心服务指标</div>
                <div class="four-col-grid">
                    <div class="grid-cell">
                        <div class="big-text">{{ detail.duration }}</div>
                        <div class="small-text">服务周期</div>
                    </div>
                    <div class="grid-cell">
                        <div class="big-text">{{ detail.wordCount }}</div>
                        <div class="small-text">词根数量</div>
                    </div>
                    <div class="grid-cell">
                        <div class="big-text">{{ categoryDesc }}</div>
                        <div class="small-text">行业分类</div>
                    </div>
                    <div class="grid-cell">
                        <div class="big-text">{{ regionDesc }}</div>
                        <div class="small-text">投放区域</div>
                    </div>
                </div>

                <!-- 平台覆盖 -->
                <div class="platform-box">
                    <div class="platform-title">六大AI平台全覆盖:</div>
                    <div class="platform-tags">
                        <span class="plat-tag">豆包</span>
                        <span class="plat-tag">DeepSeek</span>
                        <span class="plat-tag">元宝</span>
                        <span class="plat-tag">千问</span>
                        <span class="plat-tag">Kimi</span>
                        <span class="plat-tag">文心</span>
                    </div>
                </div>

                <!-- 服务流程 -->
                <div class="section-title">服务流程</div>
                <div class="process-wrap">
                    <div class="process-list">
                        <div class="process-item">
                            <div class="process-num">01</div>
                            <div class="process-text">客户签署协议</div>
                        </div>
                        <div class="process-item">
                            <div class="process-num">02</div>
                            <div class="process-text">订单关键信息确认</div>
                        </div>
                        <div class="process-item">
                            <div class="process-num">03</div>
                            <div class="process-text">构建企业知识图谱</div>
                        </div>
                        <div class="process-item">
                            <div class="process-num">04</div>
                            <div class="process-text">AI搜索结果展现</div>
                        </div>
                        <div class="process-item">
                            <div class="process-num">05</div>
                            <div class="process-text">持续稳定优化排名</div>
                        </div>
                    </div>
                </div>

                <!-- 十大服务内容 -->
                <div class="section-title">十大服务内容细节</div>
                <div class="eight-grid">
                    <div class="detail-card">
                        <div class="card-badge tnum">01</div>
                        <div class="card-body">
                            <div class="card-title">多平台AI提及与排名靠前</div>
                            <div class="card-desc">针对企业指定核心关键词、行业问答词、场景需求词，做语义权重优化，承诺AI问答排名top10靠前。</div>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="card-badge tnum">02</div>
                        <div class="card-body">
                            <div class="card-title">行业竞品深度调研与AI算法拆解</div>
                            <div class="card-desc">深度解构客户所在赛道的头部竞品，系统排查其GEO布局策略、内容矩阵分层、权威信源铺设及知识图谱占位，量化对比品牌在AI平台中的提及率、推荐排名与语义覆盖差距。同时，逆向拆解主流大模型的底层抓取逻辑、语义理解偏好及权威权重判定规则，预判算法迭代方向。</div>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="card-badge tnum">03</div>
                        <div class="card-body">
                            <div class="card-title">定制化GEO全域优化审计报告</div>
                            <div class="card-desc">聚焦大模型抓取逻辑、语义偏好、权威权重判定规则开展深度分析审计报告，全面拆解品牌GEO得分，布局策略、内容结构、媒体背书、知识图谱占位情况，精准定位客户行业流量空白点、AI排名短板、场景缺口。</div>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="card-badge tnum">04</div>
                        <div class="card-body">
                            <div class="card-title">AI友好型结构化官网搭建与底层优化</div>
                            <div class="card-desc">（此服务单独收费，建议选择）深度云海AI灵雀智能建站系统帮助企业快速搭建智能官网，采用植入Schema结构化标签、EEAT权威信号模块，优化网站抓取路径、页面层级、内容结构，从底层解决大模型“抓不到、读不懂、不采信”的核心问题。</div>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="card-badge tnum">05</div>
                        <div class="card-body">
                            <div class="card-title">AI原生专业内容矩阵创作与全域分发</div>
                            <div class="card-desc">内容严格适配大模型语义训练逻辑、知识收录规则、原创判定机制，保障内容可被AI优先引用、高频推荐。同步完成多平台全域分发，覆盖AI问答场景、搜索场景、资讯场景，最大化品牌曝光密度。</div>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="card-badge tnum">06</div>
                        <div class="card-body">
                            <div class="card-title">权威媒体背书与品牌公信力建设</div>
                            <div class="card-desc">针对大模型权威权重、可信度判定机制，对接主流权威媒体、行业垂直平台进行品牌合规发稿与背书沉淀。提升品牌在大模型体系内的EEAT信任分值，解决新品牌、小众品牌AI收录权重低、排名靠后的核心痛点。</div>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="card-badge tnum">07</div>
                        <div class="card-body">
                            <div class="card-title">搭建企业知识图谱</div>
                            <div class="card-desc">运用图数据库与语义检索技术构建企业私有知识大脑，关联非结构化数据与业务实体，搭建RAG混合检索架构，消除数据孤岛与语义断层。从底层解决大模型“答非所问、幻觉频出、知识滞后”的核心痛点，构建大模型精准知识调用为交付标准。</div>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="card-badge tnum">08</div>
                        <div class="card-body">
                            <div class="card-title">全平台排名监测与精细化迭代优化</div>
                            <div class="card-desc">依托自研监测系统，实时监控AI平台关键词排名、问答曝光率、内容收录量、渗透率数据，企业AEO情感分析等。根据大模型算法微调，动态调整内容策略、词库结构、投喂频率、分发渠道，动态维稳排名、持续提升渗透率，杜绝排名断崖下跌。</div>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="card-badge tnum">09</div>
                        <div class="card-body">
                            <div class="card-title">八大纬度构建合规GEO标准</div>
                            <div class="card-desc">依托国际主流大模型算法机制搭建合规内容矩阵，融合自然语言处理与权威引文策略，规避黑帽堆砌与违规风险。从底层解决品牌内容“被限流、遭屏蔽、难收录”的传播难题，以正向舆情引导与高价值触达为交付结果。</div>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="card-badge tnum">10</div>
                        <div class="card-body">
                            <div class="card-title">全年优化运营指导与售后保障</div>
                            <div class="card-desc">全年提供策略调整、内容优化、数据答疑、舆情提醒、突发排名修复、新词扩容等增值服务。针对算法更新、竞品恶意抢占、行业流量波动等问题提供应急优化方案，持续放大品牌AI流量优势。全程透明化服务、数据可查、效果可追溯，保障全年排名稳定、流量持续增长。</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /main-content -->

            <!-- Footer -->
            <div class="page-footer">
                <div class="footer-company">深度云海智能科技（上海）有限公司</div>
                <div class="footer-url">www.deepagens.com</div>
            </div>
        </template>
    </div>
</template>

<script>
import { getQuotationShareDetail, specialOfferPriceType, activityPriceType } from "@/api/quotation";

export default {
    name: "QuotationShare",
    data() {
        return {
            shareCode: "",
            loading: true,
            error: "",
            detail: null,
            specialOfferPriceType,
            activityPriceType,
        };
    },
    computed: {
        categoryDesc() {
            if (!this.detail) return "";
            return this.detail.category + (this.detail.subCategory ? " - " + this.detail.subCategory : "");
        },
        regionDesc() {
            if (!this.detail) return "";
            var provinces = this.detail.provinceList || [];
            var cities = this.detail.cityList || [];
            if (provinces.length === 0) return "未指定";
            var pStr = provinces.join(",");
            var cStr = cities.join(",");
            return pStr + (cStr ? "-" + cStr : "");
        },
    },
    created() {
        this.shareCode = this.$route.params.shareCode || "";
        if (!this.shareCode) {
            this.error = "分享码无效";
            this.loading = false;
            return;
        }
        this.fetchDetail();
        document.documentElement.style.backgroundColor = "#f6f9fc";
        document.body.style.backgroundColor = "#f6f9fc";
        document.body.style.color = "#333";
    },
    beforeDestroy() {
        document.documentElement.style.backgroundColor = "";
        document.body.style.backgroundColor = "";
        document.body.style.color = "";
    },
    methods: {
        fetchDetail() {
            var that = this;
            that.loading = true;
            getQuotationShareDetail(that.shareCode)
                .then(
                    function (res) {
                        that.detail = res.data || null;
                        if (!that.detail) {
                            that.error = "分享页面数据为空";
                        }
                    },
                    function (e) {
                        that.error = (e || "加载失败").toString().replace(/^Error:\s*/i, "");
                    }
                )
                .finally(function () {
                    that.loading = false;
                });
        },
    },
};
</script>

<style scoped>
/* ============================================================
   GLOBAL & BASE
   ============================================================ */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.share-page {
    max-width: 960px;
    margin: 0 auto;
    background: #ffffff;
    min-height: 100vh;
    font-family: Inter, "SF Pro Display", system-ui, -apple-system, sans-serif;
    font-feature-settings: "ss01";
    color: #0d253d;
}

.tnum {
    font-feature-settings: "tnum", "ss01";
}

/* ============================================================
   TOP BAR
   ============================================================ */
.top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(135deg, #533afd 0%, #6366f1 50%, #8338ec 100%);
    color: #ffffff;
}

.logo-box {
    background: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 12px;
    flex-shrink: 0;
    align-self: stretch;
}

.logo-img {
    width: 120px;
    height: 60px;
    object-fit: contain;
    display: block;
}

.top-bar-left {
    flex: 1;
    min-width: 0;
    text-align: left;
    padding: 8px 24px 8px 16px;
}

.top-bar-title {
    font-size: 20px;
    font-weight: 300;
    line-height: 1.2;
    letter-spacing: -0.2px;
    margin: 0;
}

.top-bar-sub {
    font-size: 12px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.75);
    margin-top: 2px;
    letter-spacing: 0.2px;
}

.top-bar-right {
    flex-shrink: 0;
    margin-left: 16px;
    padding-right: 24px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.top-brand {
    font-size: 15px;
    font-weight: 400;
    color: #ffffff;
    letter-spacing: 0.5px;
}

.top-divider {
    width: 1px;
    height: 14px;
    background: rgba(255, 255, 255, 0.35);
    flex-shrink: 0;
}

.top-tagline {
    font-size: 15px;
    font-weight: 400;
    color: #ffffff;
    letter-spacing: 0.5px;
}

/* ============================================================
   MAIN CONTENT
   ============================================================ */
.main-content {
    padding: 24px;
}

/* ============================================================
   LOADING & ERROR
   ============================================================ */
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.error-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.error-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(234, 34, 97, 0.1);
    color: #ea2261;
    font-size: 32px;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
}

.error-text {
    font-size: 15px;
    font-weight: 300;
    color: #64748d;
}

/* ============================================================
   PRICE BAR
   ============================================================ */
.price-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f6f9fc;
    padding: 20px 24px;
    border-radius: 12px;
    border: 1px solid #e3e8ee;
    margin-bottom: 32px;
}

.tag-row {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}

.tag-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 400;
    letter-spacing: -0.39px;
    color: #64748d;
    white-space: nowrap;
}

.tag-icon.green {
    color: #23b959;
}
.tag-icon.blue {
    color: #533afd;
}
.tag-icon.orange {
    color: #f59e0b;
}

.price-text {
    text-align: right;
}

.price-desc {
    font-size: 13px;
    font-weight: 400;
    letter-spacing: -0.39px;
    color: #64748d;
    margin-bottom: 4px;
}

.price-type-tag {
    background: #b9b9f9;
    color: #4434d4;
    padding: 3px 8px;
    border-radius: 9999px;
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.1px;
    text-transform: uppercase;
}

.price-type-tag.activity {
    background: #f59e0b;
    color: #ffffff;
}

.price-row {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    gap: 10px;
}

.price-original {
    font-size: 14px;
    font-weight: 300;
    letter-spacing: -0.42px;
    color: #64748d;
    text-decoration: line-through;
}

.price-num {
    font-size: 32px;
    font-weight: 300;
    letter-spacing: -0.64px;
    line-height: 1.1;
    color: #533afd;
}

/* ============================================================
   SECTION TITLE
   ============================================================ */
.section-title {
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 1.4;
    color: #0d253d;
    margin: 32px 0 16px;
    display: flex;
    align-items: center;
}

.section-title::before {
    content: "";
    width: 3px;
    height: 18px;
    background: #533afd;
    border-radius: 2px;
    margin-right: 10px;
    flex-shrink: 0;
}

/* ============================================================
   FOUR-COL GRID (Core Metrics)
   ============================================================ */
.four-col-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 24px;
}

.grid-cell {
    background: #533afd;
    color: #ffffff;
    text-align: center;
    padding: 20px 8px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(83, 58, 253, 0.2);
}

.grid-cell .big-text {
    font-size: 20px;
    font-weight: 300;
    letter-spacing: -0.2px;
    margin-bottom: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-feature-settings: "tnum", "ss01";
}

.grid-cell .small-text {
    font-size: 13px;
    font-weight: 400;
    letter-spacing: -0.39px;
    opacity: 0.85;
}

/* ============================================================
   PLATFORM BOX
   ============================================================ */
.platform-box {
    border: 1px solid #e3e8ee;
    border-radius: 12px;
    padding: 16px 20px;
    margin-bottom: 24px;
    background: #ffffff;
}

.platform-title {
    font-size: 14px;
    font-weight: 300;
    color: #64748d;
    margin-bottom: 12px;
    text-align: left;
}

.platform-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.plat-tag {
    background: #b9b9f9;
    color: #4434d4;
    padding: 6px 14px;
    border-radius: 9999px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
}

/* ============================================================
   PROCESS FLOW
   ============================================================ */
.process-wrap {
    margin-bottom: 24px;
}

.process-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.process-item {
    flex: 1;
    min-width: 120px;
    text-align: center;
    position: relative;
    padding: 20px 10px;
    background: #f6f9fc;
    border-radius: 12px;
    border: 1px solid #e3e8ee;
}

.process-item:not(:last-child)::after {
    content: "\2192";
    position: absolute;
    right: -16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #533afd;
    font-weight: 300;
}

.process-num {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #533afd;
    color: #ffffff;
    border-radius: 9999px;
    margin: 0 auto 10px;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: -0.39px;
    font-feature-settings: "tnum", "ss01";
}

.process-text {
    font-size: 14px;
    font-weight: 300;
    color: #0d253d;
    line-height: 1.4;
}

/* ============================================================
   DETAIL CARDS (Service Content)
   ============================================================ */
.eight-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}

.detail-card {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    background: #f6f9fc;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid #e3e8ee;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.detail-card:hover {
    box-shadow: rgba(0, 55, 112, 0.08) 0 8px 24px, rgba(0, 55, 112, 0.04) 0 2px 6px;
    transform: translateY(-2px);
}

.card-badge {
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #533afd;
    color: #ffffff;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.42px;
    flex-shrink: 0;
    box-shadow: 0 2px 6px rgba(83, 58, 253, 0.3);
}

.card-body {
    flex: 1;
    min-width: 0;
    text-align: left;
}

.card-title {
    font-size: 15px;
    font-weight: 400;
    letter-spacing: 0;
    color: #0d253d;
    margin-bottom: 6px;
    line-height: 1.3;
    font-feature-settings: "ss01";
}

.card-desc {
    font-size: 13px;
    font-weight: 300;
    line-height: 1.65;
    color: #64748d;
    text-align: left;
}

/* ============================================================
   FOOTER
   ============================================================ */
.footer-info {
    margin-top: 32px;
    padding: 16px 0;
    border-top: 1px solid #e3e8ee;
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: -0.39px;
    color: #64748d;
}

/* ============================================================
   PAGE FOOTER
   ============================================================ */
.page-footer {
    margin-top: 40px;
    padding: 24px;
    border-top: 1px solid #e3e8ee;
    text-align: center;
}

.footer-company {
    font-size: 14px;
    font-weight: 400;
    color: #64748d;
    letter-spacing: 0;
}

.footer-url {
    font-size: 13px;
    font-weight: 300;
    color: #533afd;
    margin-top: 4px;
    letter-spacing: 0.2px;
}

/* ============================================================
   RESPONSIVE
   ============================================================ */
@media (max-width: 768px) {
    /* Top Bar */
    .top-bar {
        flex-wrap: wrap;
    }

    .logo-box {
        padding: 0 10px;
    }

    .logo-img {
        width: 110px;
        height: 55px;
    }

    .top-bar-left {
        flex: 1;
        min-width: 0;
        padding: 12px 12px 10px 8px;
        text-align: left;
    }

    .top-bar-title {
        font-size: 19px;
    }

    .top-bar-sub {
        font-size: 12px;
        margin-top: 4px;
    }

    .top-bar-right {
        width: 100%;
        margin-left: 0;
        background: #ffffff;
        padding: 14px 16px;
        justify-content: center;
    }

    .top-brand {
        font-size: 13px;
        color: #4434d4;
        letter-spacing: 0.8px;
    }

    .top-divider {
        background: #b9b9f9;
    }

    .top-tagline {
        font-size: 13px;
        color: #4434d4;
    }

    /* Main Content */
    .main-content {
        padding: 16px;
    }

    /* Price Bar */
    .price-bar {
        flex-direction: column;
        align-items: flex-start;
        gap: 14px;
        padding: 16px;
        margin-bottom: 24px;
    }

    .tag-row {
        gap: 12px;
        flex-wrap: nowrap;
    }

    .tag-item {
        font-size: 13px;
    }

    .price-text {
        text-align: left;
        width: 100%;
    }

    .price-row {
        justify-content: flex-start;
    }

    .price-num {
        font-size: 28px;
    }

    /* Section */
    .section-title {
        font-size: 16px;
        margin: 24px 0 12px;
    }

    /* Grid */
    .four-col-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }

    .grid-cell {
        padding: 16px 6px;
    }

    .grid-cell .big-text {
        font-size: 18px;
    }

    /* Process */
    .process-item:not(:last-child)::after {
        display: none;
    }

    .process-item {
        min-width: 0;
        flex-basis: calc(50% - 8px);
    }

    /* Cards */
    .eight-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .detail-card {
        padding: 16px;
        gap: 12px;
    }

    .card-badge {
        width: 32px;
        height: 32px;
        line-height: 32px;
        font-size: 13px;
        border-radius: 8px;
    }

    .card-title {
        font-size: 14px;
    }

    .card-desc {
        font-size: 12px;
    }

    /* Footer */
    .footer-info {
        flex-direction: column;
        gap: 4px;
    }

    /* Page Footer */
    .page-footer {
        margin-top: 24px;
        padding: 20px 16px;
    }

    .footer-company {
        font-size: 13px;
    }

    .footer-url {
        font-size: 12px;
    }
}
</style>
